module.exports = __webpack_public_path__ + "static/csharp-de83b3acae97cfb5cc771ec5f9d710d5.png";